import { c as _c } from "react/compiler-runtime";
export const MenuNewBadge = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="rounded-2xs -mt-4 ml-2 inline-block h-5 w-9 rounded-bl-none bg-red-500 px-1.5 py-0.5"><span className="text-caption absolute text-white">ใหม่!</span></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};